export default __webpack_public_path__ + "static/messages-modal-db3401a043b2a69cc73cc1324eb0a6dd530960867fd806dd91595e78a63da5c6.jpg";